import React from 'react';

export const statusColors: Record<string, string> = {
    Match: '#28a745',
    ChildDiff: '#e6a817',
    Mismatch: '#dc3545',
    DBOnly: '#fd7e14',
    SPOnly: '#6f42c1'
};

export const statusDisplayLabels: Record<string, string> = {
    ChildDiff: 'Child Diff'
};

export const statusCellRender = (cellData: any) => {
    const color = statusColors[cellData.value] || '#333';
    const label = statusDisplayLabels[cellData.value] || cellData.value;
    return <span style={{ color, fontWeight: 'bold' }}>{label}</span>;
};

export const differencesCellRender = (cellData: any) => {
    const diffs: string[] = cellData.value || [];
    if (diffs.length === 0) return <span></span>;
    return <span style={{ color: '#dc3545' }}>{diffs.join('; ')}</span>;
};

export const nameCellRender = (cellData: any) => {
    return <span>{cellData.value}</span>;
};
